import { API_URL } from "@/config/constants";
import { buildUrl } from "@/utils/buildUrl";
import axios from "axios";
import { ILibraryFolder } from "../library-folders/library-folders.types";
import {
    IClient,
    IClientCreate,
    IClientDetail,
    IClientMinimal,
    IClientsFilter,
    IClientsPage,
    IClientStats,
    IClientUpdate,
} from "./clients.types";

const API = `${API_URL}/clients`;

export const getClients = async (
    page = 1,
    size = 50,
    filter?: IClientsFilter
) => {
    const url = buildUrl(API, { page, size, ...filter });
    const result = await axios.get<IClientsPage>(url);
    return result.data;
};

export const getClientStats = async () => {
    const result = await axios.get<IClientStats>(`${API}/stats`);
    return result.data;
};

export const getClientsMinimal = async () => {
    const result = await axios.get<IClientMinimal[]>(`${API}/minimal`);
    return result.data;
};

export const searchClients = async (q: string, limit = 10) => {
    const result = await axios.get<IClientMinimal[]>(`${API}/search`, {
        params: { q, limit },
    });
    return result.data;
};

export const getClient = async (id: number) => {
    const result = await axios.get<IClientDetail>(`${API}/${id}`);
    return result.data;
};

/**
 * Resolve-or-create the client's root library folder (Unit 3.2).
 * A read-shaped POST: 200 whether the root pre-existed or was created.
 */
export const resolveClientRootFolder = async (id: number) => {
    const result = await axios.post<ILibraryFolder>(`${API}/${id}/root-folder`);
    return result.data;
};

export const createClient = async (data: IClientCreate) => {
    const result = await axios.post<IClient>(API, data);
    return result.data;
};

export const updateClient = async (id: number, data: IClientUpdate) => {
    const result = await axios.put<IClient>(`${API}/${id}`, data);
    return result.data;
};

export const deleteClient = async (id: number) => {
    await axios.delete(`${API}/${id}`);
};
